import { Grid } from "@mui/material";
import { Content } from "models/content/Content";
import { SimpleEditor } from '@/components/tiptap-templates/simple/simple-editor'

export const ContentText = ({
  content,
  setContent,
}: {
  content: Content;
  setContent: (content: Content) => void;
}) => {
  const handleUpdate = (text: string) => {
    content.text = text;
    setContent(content);
  };

  return (
    <Grid container>
      <Grid size={12}>
        <SimpleEditor
          content={content.text}
          onUpdate={handleUpdate}
        />
      </Grid>
    </Grid>
  );
};
